export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hey, I'm Chiranjib</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">UI/UX</span>{" "}
            <br />
            Developer & Designer
          </h1>
          <p className="hero--section-description">
          I craft digital experiences where functionality meets creativity. With a passion for clean code, intuitive interfaces, and bold visual storytelling,
           I turn ideas into seamless, user-centered products. From front-end development to full-scale web architecture and pixel-perfect design,
           I blend technical precision with artistic vision to create websites and applications that don't just work — they resonate.
            <br /> Whether it's building interactive platforms, refining user journeys, or designing elegant interfaces, I believe every project is an opportunity 
            to innovate and inspire. Let’s build something extraordinary.
          </p>
        </div>
        <button className="btn btn-primary">Get In Touch</button>
      </div>
      <div className="hero--section--img">
        <img src="./img/hero_img.png" alt="Hero Section" />
      </div>
    </section>
  );
}
